import { render } from "./ModalInfoComponent.vue?vue&type=template&id=40e0b0ad&scoped=true"
import script from "./ModalInfoComponent.vue?vue&type=script&lang=js"
export * from "./ModalInfoComponent.vue?vue&type=script&lang=js"

import "./ModalInfoComponent.vue?vue&type=style&index=0&id=40e0b0ad&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e0b0ad"]])

export default __exports__